import {
  PARTNER_SETTINGS_CHANGE_VALUE,
  PARTNER_SETTINGS_CHANGE_VALUES,
} from '@shared/store/constants/mutationTypes';

const mutations = {
  [PARTNER_SETTINGS_CHANGE_VALUE]: (state, payload) => {
    const {
      field,
      value,
    } = payload;
    state[field] = value;
  },
  [PARTNER_SETTINGS_CHANGE_VALUES]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      state[field] = value;
    });
  },
};

export default mutations;
